/*------------------------------------------------
   VARIATIONS - more than one product in the page
-------------------------------------------------- */
// version 1.0 - 2025-07-30
//
// requires formatMoney function in js-common.js
Variations = {
    init: function () {
        function refreshPrice(pid) {
            let variant = currentSelectedComboProperties(pid);
            if (!variant) {
                // update price
                let el = $("[name='price']");
                $(el).html("-");
                if (variant != '') {
                    console.info("Variants Selector: Current selected variant not found on combo, cannot update price");
                }
                return;
            }

            // update price
            let el = $("[name='price']");
            $(el).attr("data-price", variant[4]);
            $(el).attr("data-price-sale", variant[5]);
            $(el).html(formatMoney(variant[4]));

            if (variant[4] != variant[5] && variant[5] > 0) $(".price__sale .price-item").html(formatMoney(variant[5]));
            else $(".price__sale .price-item").html("");

            // update id
            let addButton = $('.button-add-cart[data-pid="' + pid + '"]');
            if (addButton.length) {
                $(addButton).attr("data-id", variant[1]);
            } else {
                console.info("Variants Selector: Add to cart data-pid not found");
                return;
            }
            $(".product-form input.product-variant-id").val(variant[1]);

            // if unavailable, set class
            if (!variant[2]) {
                $(".button-add-cart").addClass("product-unavailable");
                $(".button-add-cart").removeClass("product-available");
                $(".product__info__bottom__action").addClass('no-stock');
            } else {
                $(".button-add-cart").removeClass("product-unavailable");
                $(".button-add-cart").addClass("product-available");
                $(".product__info__bottom__action").removeClass('no-stock');
            }


            // CHANGE URL
            var url = window.location.href;
            var parts = url.split("?");
            var urlWithoutParams = parts[0];
            urlWithoutParams += "?variant=" + variant[1];
            history.pushState(null, null, urlWithoutParams);
        }
        function GotoImages(pid) {
            let variant = currentSelectedComboProperties(pid);
            if (variant !== undefined && variant[6] != null) {
                /*
                let image = $('.product__images').find('[data-media="' + variant[6] + '"]');
                var height_menu = $(".header-menu").outerHeight();
                $('html, body').animate({
                    scrollTop: parseInt(image.offset().top - height_menu)
                }, 300);
                */

                /* SWIPER HASH NAVIGATION*/
                var id_image = variant[6];
                window.location.hash = id_image;
            }
        }

        // handle variants clicks (swatches)
        $(".variant_option").on("click", function (e) {
            // get product id
            let variants = $(this).closest('[data-variant-selector]');
            if (variants.length == 0) console.info("Variants Selector: no product ID found");
            let pid = Number(variants.attr('data-variant-selector'));
            checkCombo(pid, $(this)[0]);
            refreshPrice(pid);
            GotoImages(pid);
        });

        //
        // VARIATIONS COMBO CHECKER
        //
        // vars
        let sections = new Map();
        let currentSelected = new Map();
        let availableCombos = new Map();

        // set button styles according to availability
        function setButtonStyle(pid, but) {
            if (!but) return null;

            const [level, ...pname] = $(but).attr('data-variation').split("|");

            // filter available combos that fits criteria
            let filt = [];

            for (combo of availableCombos.get(pid)) {
                const cols = combo[0].split(" / ");

                // check if this combo contains this variant
                if (cols[level] == pname) filt.push(combo);
            }

            // never should happen...
            if (filt.length == 0) {
                console.info("Variants Selector: Invalid Combo");
                return null;
            }

            // for each section
            for (let s = 0; s < sections.get(pid).length; s++) {
                if (s == level) continue;
                // for each option
                let dropdowns = false;
                let buttons = $(sections.get(pid)[s]).find(".variant_option");
                if (buttons.length == 0) {
                    buttons = $(sections.get(pid)[s]).find(".variant_option_dropdown>option");
                    dropdowns = true;
                }

                for (el of buttons) {
                    // clear no stock class
                    $(el).removeClass("product-unavailable");
                    $(".product__info__bottom__action").removeClass('no-stock');
                    if (!dropdowns) $(el).parent().removeClass("butNoStock");
                    let flag = "butNo";
                    // check if in cols of available combos
                    for (combo of filt) {
                        const cols = combo[0].split(" / ");
                        for (let r = 0; r < cols.length; r++) {
                            if (r == level) continue;
                            if (r + "|" + cols[r] == $(el).attr("data-variation")) {
                                $(el).removeClass(flag);
                                if (!dropdowns) (flag == "product-unavailable" ? $(el).parent().removeClass("butNoStock") : $(el).parent().removeClass(flag));

                                flag = "";
                                if (!combo[2]) flag = "product-unavailable";
                                if (dropdowns && flag == "") {
                                    $(el).html($(el).attr('data-variation').split("|")[1]);
                                    $(el).prop('disabled', false);
                                }

                                break;
                            }
                        }
                        if (flag.length) {
                            $(el).addClass(flag);
                            if (dropdowns) {
                                if (flag == "product-unavailable") {
                                    $(el).html($(el).attr('data-soldout'));
                                    $(el).prop('disabled', true);
                                }
                            }
                            if (!dropdowns) (flag == "product-unavailable" ? $(el).parent().addClass("butNoStock") : $(el).parent().addClass(flag));
                        }

                        if (currentSelected.get(pid)[s] == el) {
                            $(el).addClass("butSelect");
                            if (!dropdowns) $(el).parent().addClass("butSelect");
                        } else {
                            $(el).removeClass("butSelect");
                            if (!dropdowns) $(el).parent().removeClass("butSelect");
                        }
                    }
                }
            }
        }


        // init all controls ids and disable unavailable
        function initComboCheck(products) {
            availableCombos = new Map();
            for (const product of products) {
                // get all possible combos from liquid
                let variants = $(product).find('.variants-json');
                let pid = $(variants).data('pid');
                $(product).attr('data-variant-selector', pid);
                let start_select = $(variants).attr('data-start-select');

                let vars = JSON.parse($(variants).html());
                availableCombos.set(pid, []);
                for (let i = 0; i < vars.length; i++) {
                    let v = vars[i];
                    // DON'T CHANGE FIELD ORDER
                    availableCombos.get(pid).push([v["title"], v["id"], v["available"], v["inventory"], v["price"], v["compare_at_price"], v["media"]]);
                };

                let level = 0;
                currentSelected.set(pid, []);
                sections.set(pid, []);
                $(product).find('[name="variant_section"]').each(function () {
                    sections.get(pid).push($(this));
                });
                for (const section of sections.get(pid)) {
                    // write current level to id
                    section.id = level;
                    let dropdowns = false;

                    let buttons = $(section).find(".variant_option");
                    if (buttons.length == 0) {
                        buttons = $(section).find(".variant_option_dropdown>option");
                        dropdowns = true;
                    }

                    for (let but of buttons) {
                        $(but).attr('data-variation', level + "|" + $(but).val().replaceAll(" / ", "/"));
                        // check if available
                        $(but).prop('disabled', true);
                        // set no stock on unique level variants, we'll clear it later if necessary
                        if (sections.get(pid).length == 1) $(but).parent().addClass("butNoStock");
                        for (combo of availableCombos.get(pid)) {
                            const cols = combo[0].split(" / ");

                            // check if this combo contains this variant
                            if (cols[level] == $(but).val().replaceAll(" / ", "/")) {
                                $(but).prop('disabled', false);
                                // if there is stock (for unique level initial parsing), clear no stock class
                                if (sections.get(pid).length == 1 && combo[2]) $(but).parent().removeClass("butNoStock");
                                break;
                            }
                        }

                        // get current selected button
                        if (start_select === "true") {
                            if (dropdowns && $(but).is(":selected")) {
                                let t = currentSelected.get(pid);
                                t[level] = but;
                                $(but).addClass("butSelect");
                            } else if (but.checked) {
                                let t = currentSelected.get(pid)
                                t[level] = but;
                                //but.checked = true;
                                $(but).addClass("butSelect");
                                $(but).parent().addClass("butSelect");
                            }
                        }
                    }
                    level++;
                }

                // force initial available check for each section (level)
                if (start_select === "true") {
                    for (let i = sections.get(pid).length - 1; i >= 0; i--) {
                        setButtonStyle(pid, currentSelected.get(pid)[i]);
                    }
                }

                if (currentSelected.get(pid)[0] !== undefined) {
                    refreshPrice(pid);
                }
            }
        }


        // return current selected buttons to combo path string
        function currentSelectedToComboString(pid) {
            let [level, ...comboPath] = $(currentSelected.get(pid)[0]).attr('data-variation').split("|");
            let num_sections = sections.get(pid).length;
            //comboPath[0] = comboPath[0].replaceAll(" / ", " / ");
            for (let l = 1; l < num_sections; l++) {
                if (currentSelected.get(pid)[l] == undefined) return '';
                comboPath += ' / ' + $(currentSelected.get(pid)[l]).attr('data-variation').split("|")[1];
            }

            return comboPath;
        }

        // get variant from combo string
        function comboStringToCombo(pid, pname) {
            if (pname == '') return '';
            // filter available combos that fits criteria
            for (combo of availableCombos.get(pid)) {
                if (combo[0] == pname) {
                    return combo;
                }
            }
        }

        // get current selected combo array item
        function currentSelectedComboProperties(pid) {
            return comboStringToCombo(pid, currentSelectedToComboString(pid));
        }


        // check available options after combo change
        function checkCombo(pid, but) {
            const [level, ...name] = $(but).attr("data-variation").split("|");

            // already pressed button, just exit
            //if (currentSelected.get(pid)[level] === but) return;
            currentSelected.get(pid)[level] = but;

            // recalculate available options
            setButtonStyle(pid, currentSelected.get(pid)[level]);

            // check if we must change current selected buttons because of availability
            let newBut = but;
            for (let l = 0; l < sections.get(pid).length; l++) {
                // check if we must change the selection of other levels
                if (l != level && $(currentSelected.get(pid)[l]).hasClass("butNo")) {
                    $(sections.get(pid)[l]).find("[data-variation]").each(function () {
                        // check if button is enabled
                        if (!$(this).hasClass("butNo")) {
                            newBut = $(this)[0];
                            return false;
                        }
                    });

                    // activate current selected button
                    if (currentSelected.get(pid)[l] != newBut) {
                        currentSelected.get(pid)[l] = newBut;
                        // recalculate available options
                        setButtonStyle(pid, currentSelected.get(pid)[l]);
                    }
                }
            }
            // recalculate available options, reevaluate clicked button
            setButtonStyle(pid, currentSelected.get(pid)[level]);

            // update button selected class (not dropdowns)
            for (let l = 0; l < sections.get(pid).length; l++) {
                for (but of $(sections.get(pid)[l]).find(".variant_option")) {
                    if (currentSelected.get(pid)[l] == but) {
                        $(but).addClass("butSelect");
                        $(but).parent().addClass("butSelect");
                    } else {
                        $(but).removeClass("butSelect");
                        $(but).parent().removeClass("butSelect");
                    }
                }
            }
        }

        // auto init combocheck
        $(document).ready(function () {
            if (typeof initComboCheck === 'function' && $(".variants-json").length) initComboCheck($(".variants-json").parent());
        });
    }
}

Variations.init();
